import type { TemplateDatePreset } from "../../utils/templateDateFilterTypes";
import {
  buildBetweenTsPresetFilterClause,
  type BetweenTsClause,
} from "../SendEmail/templateDateFilter";

/** Filter fragment for `/registration` list queries (Cosmos numeric epoch field). */
export type RegistrationDateFilter = {
  registrationDate: BetweenTsClause;
};

export type EventDateFilter = {
  eventDate: BetweenTsClause;
};

export function buildRegistrationDateFilter(
  preset: TemplateDatePreset,
  dateFrom: string,
  dateTo: string,
): RegistrationDateFilter | undefined {
  const clause = buildBetweenTsPresetFilterClause(preset, dateFrom, dateTo);
  if (!clause) {
    return undefined;
  }
  return { registrationDate: clause };
}

export function buildEventDateFilter(
  preset: TemplateDatePreset,
  dateFrom: string,
  dateTo: string,
): EventDateFilter | undefined {
  const clause = buildBetweenTsPresetFilterClause(preset, dateFrom, dateTo);
  if (!clause) {
    return undefined;
  }
  return { eventDate: clause };
}
